import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MaterialModule} from "../../material/material.module";
import { RegisterOwnerComponent } from './register-owner/register-owner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';



@NgModule({
  declarations: [
    RegisterOwnerComponent,
    DialogConfirmComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    
  ]
})

export class RegisterOwnerModule{};